// extracted by mini-css-extract-plugin
module.exports = {"title":"footerContact_title__3n8Kc","link":"footerContact_link__2wxAQ","contactBlock":"footerContact_contactBlock__18MLw"};
    if(module.hot) {
      // 1746134882442
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  